import { type TypeBackground, styled } from "@mui/material";

import { house, smile } from "./svg";

interface ImageWrapperProps {
  color?: "secondary" | "primary";
  housePosition?: "left" | "right";
}
export const ServiceHeroImgWrapper = styled("div")<ImageWrapperProps>`
  position: relative;
  display: flex;
  ::after,
  ::before {
    content: "";
    position: absolute;
    width: 30%;
    height: 30%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  ::before {
    background-image: ${({ color = "primary", theme }) =>
      house(theme.palette[color].light)};
    top: -15%;
    ${({ housePosition = "left" }) => housePosition} : -15%;
  }
  ::after {
    bottom: 15%;
    right: -15%;
    z-index: 2;
    background-image: ${({ theme }) => smile(theme.palette.primary.main)};
  }
`;

export const ServiceHeroImg = styled("img")`
  aspect-ratio: 1 / 1;
  max-width: 100%;
  z-index: 1;
  ::before {
    content: "";
    margin-top: 100%;
  }

  object-fit: cover;
`;

export const ServiceHeroSection = styled("section")<{
  backgroundColor: keyof TypeBackground;
}>(({ theme, backgroundColor }) => ({
  backgroundColor: theme.palette.background[backgroundColor],
  overflow: "hidden",
}));
